import { INotificationPreference, INotificationScopeItem, ISelectableFacility } from '../generated-types/notification'
import { useGet, usePut } from './reactQuery'

const baseUrl = (customerId: EntityId) => `customers/${customerId}/users/me/notification-preferences`

export const notificationPreferenceEndpoints = {
  getMine: (customerId: EntityId) => baseUrl(customerId),
  getScope: (customerId: EntityId) => `${baseUrl(customerId)}/scope`,
  getSelectableFacilities: (customerId: EntityId) => `${baseUrl(customerId)}/selectable-facilities`,
}

export const useGetMyNotificationPreferences = (customerId: EntityId) =>
  useGet<INotificationPreference[]>(notificationPreferenceEndpoints.getMine(customerId), undefined, {
    enabled: !!customerId,
  })

export const useUpdateMyNotificationPreferences = (customerId: EntityId) =>
  usePut<INotificationPreference[], { preferences: INotificationPreference[] }>(
    notificationPreferenceEndpoints.getMine(customerId),
  )

export const useGetMyNotificationScope = (customerId: EntityId) =>
  useGet<INotificationScopeItem[]>(notificationPreferenceEndpoints.getScope(customerId), undefined, {
    enabled: !!customerId,
  })

export const useGetSelectableNotificationFacilities = (customerId: EntityId) =>
  useGet<ISelectableFacility[]>(notificationPreferenceEndpoints.getSelectableFacilities(customerId), undefined, {
    enabled: !!customerId,
  })

export const useUpdateMyNotificationScope = (customerId: EntityId) =>
  usePut<INotificationScopeItem[], { scope: INotificationScopeItem[] }>(
    notificationPreferenceEndpoints.getScope(customerId),
  )
